/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BankInstitutions200,
  GetApiV1BankInstitutions401,
  GetApiV1BankInstitutions500,
  GetApiV1BankInstitutionsQueryResponse,
} from "../../types/bankAuxiliaresController/GetApiV1BankInstitutions.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BankInstitutions200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1BankInstitutions200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BankInstitutions401Schema =
  z.any() as unknown as ToZod<GetApiV1BankInstitutions401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BankInstitutions500Schema =
  z.any() as unknown as ToZod<GetApiV1BankInstitutions500>;

export const getApiV1BankInstitutionsQueryResponseSchema = z.lazy(
  () => getApiV1BankInstitutions200Schema,
) as unknown as ToZod<GetApiV1BankInstitutionsQueryResponse>;
